import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHeader, TableRow } from '../table';
import { ServiceCategory } from '../../types/service';
import { resolveServiceCategoryLabel } from '../../utils/serviceCategoryLabel';

interface ServiceCategoryTableProps {
  serviceCategories: ServiceCategory[];
  onRowClick: (serviceCategory: ServiceCategory) => void;
}

const ServiceCategoryTable: React.FC<ServiceCategoryTableProps> = ({
  serviceCategories,
  onRowClick,
}) => {
  const { t, i18n } = useTranslation(['admin', 'common', 'jobs']);

  return (
    <div className="max-w-full overflow-x-auto">
      <Table className="w-full">
        <TableHeader className="bg-gray-50 dark:bg-white/[0.05]">
          <TableRow>
            {['label', 'validated', 'created_at', 'deleted'].map(field => (
              <TableCell
                key={field}
                isHeader
                className="text-start px-6 py-4 font-semibold uppercase text-gray-600 text-[0.75rem] tracking-wide dark:text-gray-400"
              >
                {t(`table_fields.${field}`, { ns: 'admin' })}
              </TableCell>
            ))}
          </TableRow>
        </TableHeader>

        <TableBody className="divide-y divide-gray-100 dark:divide-white/[0.05]">
          {serviceCategories.map(serviceCategory => (
            <TableRow
              key={serviceCategory.id}
              onClick={() => onRowClick(serviceCategory)}
              className="cursor-pointer transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-white/[0.08]"
            >
              <TableCell className="px-6 py-4">
                {resolveServiceCategoryLabel(serviceCategory, i18n.language, t)}
              </TableCell>

              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {serviceCategory.validated
                  ? t('form_fields.yes', { ns: 'common', defaultValue: 'Oui' })
                  : t('form_fields.no', { ns: 'common', defaultValue: 'Non' })}
              </TableCell>

              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {serviceCategory.created_at
                  ? new Date(serviceCategory.created_at).toLocaleDateString()
                  : '-'}
              </TableCell>

              <TableCell className="px-6 py-4 text-gray-600 dark:text-gray-400 text-sm">
                {serviceCategory.deleted
                  ? t('form_fields.yes', { ns: 'common', defaultValue: 'Oui' })
                  : t('form_fields.no', { ns: 'common', defaultValue: 'Non' })}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ServiceCategoryTable;
